<template>
  <q-dialog
    v-model="open"
    @hide="hide($event)"
    data-testid="ok-cancel-dialog"
  >
    <q-card
      v-if="open"
      class="ok-cancel-dialog"
      data-testid="ok-cancel-dialog"
      :style="getDialogStyle()"
    >
      <q-card-section class="row items-center dialog-title-wrapper">
        <h2
          data-testid="ok-cancel-dialog-title"
          class="ibf-h2"
        >
          {{ dialogTitle }}
        </h2>
      </q-card-section>
      <q-card-section class="row items-center dialog-body-wrapper-main">
        <h6
          data-testid="ok-cancel-dialog-body"
          class="ibf-h6 Text_Medium"
        >
          {{ body }}
        </h6>
      </q-card-section>
      <q-card-section
        v-if="bodySecondary"
        class="row items-center dialog-body-wrapper"
      >
        <h6 class="ibf-h6 app_text_grey">{{ bodySecondary }}</h6>
      </q-card-section>
      <q-card-section
        v-if="bodyIcon"
        class="row items-center dialog-body-wrapper icon-container"
      >
        <div
          class="body-icon"
          :class="bodyIcon"
        ></div>
      </q-card-section>
      <q-card-section
        v-if="checkboxText"
        class="row items-center dialog-body-wrapper"
      >
        <q-checkbox
          data-testid="ok-cancel-dialog-checkbox"
          v-model="checkBoxValue"
          :label="checkboxText"
          keep-color
          class="checkbox"
        />
      </q-card-section>
      <q-card-section
        v-if="checkboxVerifyText"
        class="row items-center dialog-body-wrapper"
      >
        <q-checkbox
          data-testid="ok-cancel-dialog-verify-checkbox"
          v-model="checkBoxVerifyValue"
          :label="checkboxVerifyText"
          keep-color
          class="checkbox"
        />
      </q-card-section>
      <q-card-actions
        class="action-wrapper"
        align="center"
      >
        <q-btn
          v-close-popup
          :data-testid="elementsIds.dialogs.okCancelDialog.cancelButton"
          class="dialog-btn cancel-btn incredi-button-ibx secondary"
          :class="getButtonStyle()"
          :disable="okLoading"
          :loading="cancelLoading"
          :label="cancelLabel"
          no-caps
          flat
          rounded
          @click="cancelClicked"
        />
        <q-btn
          :data-testid="elementsIds.dialogs.okCancelDialog.okButton"
          v-close-popup
          class="dialog-btn ok-btn incredi-button-ibx primary-strong"
          :class="getButtonStyle()"
          :disable="getIsDisabled"
          :label="okLabel"
          :loading="okLoading"
          no-caps
          flat
          rounded
          @click="okClicked"
        />
      </q-card-actions>
      <div class="bottom-gradient">
        <div class="bottom-gradient1"></div>
        <div class="bottom-gradient2"></div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import elementsIds from '@/const/elementIds.json';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'IbOkCancelDialog',
  model: {
    events: ['cancel', 'ok', 'hide'],
  },
  props: {
    value: { type: Boolean, required: true },
    dialogStyle: { type: String },
    buttonStyle: { type: String },
    dialogTitle: { type: String, required: true },
    body: { type: String, required: true },
    bodySecondary: { type: String },
    bodyIcon: { type: String },
    checkboxText: { type: String },
    checkboxVerifyText: { type: String },
    okLabel: { type: String, default: 'Ok' },
    cancelLabel: { type: String, default: 'Cancel' },
  },
  setup: () => ({
    elementsIds,
  }),
  data() {
    return {
      okLoading: false,
      cancelLoading: false,
      checkBoxValue: false,
      checkBoxVerifyValue: false,
    };
  },
  computed: {
    getIsDisabled: {
      get() {
        return this.cancelLoading || (this.checkboxVerifyText !== undefined && !this.checkBoxVerifyValue);
      },
    },
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    value() {
      if (this.value) {
        this.checkBoxValue = false;
        this.checkBoxVerifyValue = false;
      }
    },
  },
  methods: {
    okClicked() {
      this.okLoading = true;
      const options = {};
      if (this.checkboxText) {
        options.checkBoxValue = this.checkBoxValue;
      }
      if (this.checkboxVerifyText) {
        options.checkBoxVerifyValue = this.checkBoxVerifyValue;
      }
      this.$emit('ok', options);
    },
    cancelClicked() {
      this.cancelLoading = true;
      this.$emit('cancel');
    },
    hide() {
      this.okLoading = false;
      this.cancelLoading = false;
      this.checkBoxValue = false;
      this.checkBoxVerifyValue = false;
      this.$emit('hide');
    },
    getDialogStyle() {
      return this.dialogStyle ? this.dialogStyle : '';
    },
    getButtonStyle() {
      return this.buttonStyle ? this.buttonStyle : '';
    },
  },
});
</script>

<style lang="scss" scoped>
.ok-cancel-dialog {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 232px;
  width: 432px;
  overflow: hidden;
}
h2,
h6 {
  line-height: 25px;
  margin: 0;
  text-align: center;
  width: 100%;
}
.dialog-title-wrapper {
  margin-top: 32px;
  margin-bottom: 16px;
  padding: 0;
  & .ibf-h2 {
    width: 100%;
    text-align: center;
  }
}
.dialog-body-wrapper {
  padding-top: 0;
}
.dialog-body-wrapper-main {
  padding: 0 24px 24px 24px;
}
.dialog-btn {
  min-width: 32px;
}
.bottom-gradient {
  position: absolute;
  bottom: 0;
  left: 0%;
  height: 24px;
  width: 100%;
}
.bottom-gradient1 {
  position: absolute;
  height: 24px;
  left: 0%;
  right: -0.23%;
  bottom: 0px;

  background: linear-gradient(90deg, rgba(0, 240, 185, 0.859375) -3.46%, #00f0b9 10.68%, rgba(0, 240, 185, 0) 50.87%);
  opacity: 0.5;
}

.bottom-gradient2 {
  position: absolute;
  height: 17px;
  left: 0%;
  right: 0%;
  bottom: -1px;

  background: linear-gradient(70.93deg, #0bece2 26.54%, #03e8b4 67.13%);
  opacity: 0.8;
}

.warning .bottom-gradient1 {
  background: linear-gradient(90deg, #fff5d1 -3.46%, #ffe895 10.68%, #fff5d1 50.87%);
}

.warning .bottom-gradient2 {
  background: linear-gradient(70.93deg, #ffd02b 26.54%, #fff5d1 67.13%);
}

.danger .bottom-gradient1 {
  background: linear-gradient(90deg, #ffeeee -3.46%, #fba4b3 10.68%, #ffeeee 50.87%);
}

.danger .bottom-gradient2 {
  background: linear-gradient(70.93deg, #eb0028 26.54%, #ffeeee 67.13%);
}

.warning .primary-strong {
  background-color: $-brand-yellow;
}
.warning .secondary {
  color: $-brand-yellow;
}

.danger .primary-strong {
  background-color: $-system-app-error;
}
.danger .secondary {
  color: $-system-app-error;
}

.failure.incredi-button-ibx.primary-strong {
  background-color: $-system-app-grey-22;
}
.failure.incredi-button-ibx.secondary {
  color: $-system-app-grey-22;
}

.primary-strong.disabled,
.danger .primary-strong.disabled,
.warning .primary-strong.disabled {
  background-color: $-status-status-offline;
}
.icon-container {
  display: flex;
  justify-content: center;
  & .body-icon {
    width: 94px;
    height: 108px;
    zoom: 0.5;
  }
  & .body-icon.warning {
    background: url('@/assets/images/warning.png') no-repeat;
  }
}

.action-wrapper {
  margin-top: auto;
  margin-bottom: 33px;
  width: 100%;
}

.checkbox {
  border: 2px;
  font-size: 13px;
  margin-bottom: 17px;

  :deep(.q-checkbox__bg) {
    color: $-system-app-primary;
  }

  :deep(.q-checkbox__inner--truthy .q-checkbox__bg) {
    color: $-system-app-primary;
  }

  :deep(.q-checkbox__inner:before) {
    background: transparent !important;
  }

  :deep(.q-checkbox__label) {
    color: $-text-text-low-old;
  }
}
.warning .checkbox {
  :deep(.q-checkbox__bg) {
    color: $-brand-yellow;
  }

  :deep(.q-checkbox__inner--truthy .q-checkbox__bg) {
    color: $-brand-yellow;
  }
}

.danger .checkbox {
  :deep(.q-checkbox__bg) {
    color: $-system-app-error;
  }

  :deep(.q-checkbox__inner--truthy .q-checkbox__bg) {
    color: $-system-app-error;
  }
}
</style>
